import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

const CoverPreview = ({ imageSrc }) => {
  
  return (
    <Box
      sx={{
        height: 200,
        width: "100%",
        bgcolor: "rgba(0,0,0,0.04)",
        borderRadius: 1,
        overflow: "hidden",
        mb: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {imageSrc ? (
        <img
          src={imageSrc}
          alt="Header preview"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : (
        <Typography variant="body2" color="text.secondary">
          No image selected
        </Typography>
      )}
    </Box>
  );
};

CoverPreview.propTypes = {
  imageSrc: PropTypes.string,
};

export default CoverPreview;
